<section class="columnsDropdown">
  <header>
    <h6>
      {{ 'table_columns' | ppTranslate }}
      <pp-info-icon
        ppClass="setSize14"
        ppTooltip
        [ppOptions]="{ placement: 'right' }"
        [ppMobileTooltip]="true"
        [ppSanitize]="false"
        ppTitle="<div style='text-align: left'>
        {{ 'table_columns_dropdown_tooltip_1' | ppTranslate }}
          <br/><br/>
          {{ 'table_columns_dropdown_tooltip_2' | ppTranslate }}
          <br/><br/>
          {{ 'table_columns_dropdown_tooltip_3' | ppTranslate }}
      </div>"
      ></pp-info-icon>
    </h6>

    <pp-saved-view-preview-header
      [ppHideText]="true"
      [ppWorkspaceId]="workspace?.workspaceId"
      (ppSaveToCurrentView)="saveColumnsToView()"
      [ppProcessing]="saveViewProcessing"
    ></pp-saved-view-preview-header>
  </header>

  @if (searchBarVisible) {
    <pp-search-box
      class="columnsDropdown__search"
      [ppPlaceholder]="'filter_items' | ppTranslate"
      [ppFocusOnInit]="true"
      ppSize="wide"
      (ppAction)="onSearch($event)"
    ></pp-search-box>
  }

  <div class="columnsDropdown__border-wrapper">
    @if (draggedColumn !== null) {
      <div class="columnsDropdown__cell--border" [style.marginTop.px]="linePosition"></div>
    }
  </div>
  <div class="columnsDropdown__columns-table" (scroll)="scrollHandler($event)">
    <div class="columnsDropdown__table-content" #columnTable>
      @for (row of filteredColumns; track row.column; let index = $index) {
        <div
          [class.columnsDropdownItem--opacity]="draggedColumn?.name === row.column.name"
          (dragover)="onDragOver($event, index, row.column)"
          (drop)="onDrop($event)"
          (dragend)="onDragEnd()"
        >
          <label
            id="{{ 'itemRow-' + row.column.name }}"
            class="columnsDropdown__label"
            [class.columnsDropdown__label--static]="isFiltered"
            [draggable]="!isFiltered"
            (dragstart)="onDragStart($event, index, row.column)"
          >
            <div class="columnsDropdown__flex-container" ppTooltip [ppTitle]="row.iconTooltip">
              @if (!isFiltered) {
                <pp-icon
                  [ppSrc]="EIconPath.ICON_DRAG_18"
                  ppColor="grey-400"
                  [ppDisplayContents]="true"
                  ppClass="setSize18"
                ></pp-icon>
              }

              <pp-icon [ppSVG]="row.icon" ppColor="grey-600" [ppDisplayContents]="true" />
              <p
                ppTooltip
                [ppTrimTooltip]="true"
                [ppTitle]="row.column.name"
                class="columnsDropdown__name"
              >
                {{ row.label }}
              </p>
            </div>
            <pp-toggle
              (ppAction)="updateColumnValue(row.column)"
              [ppChecked]="!row.column.hidden"
              ppStyle="columns"
              [ppDisabled]="
                columns.hidden.length === columns.data.length - 1 &&
                columns.hidden.indexOf(row.column.index) === -1
              "
            >
            </pp-toggle>
          </label>
        </div>
      }

      @if (filteredColumns && filteredColumns.length === 0) {
        <p class="columnsDropdown__empty">{{ 'no_columns_found' | ppTranslate }}</p>
      }
    </div>
  </div>

  <hr />

  <footer>
    @if (!scrolledToBottom) {
      <div class="columnsDropdown__shadow">&nbsp;</div>
    }

    <div class="columnsDropdown__footer-buttons">
      <pp-button
        [ppTooltipTitle]="'reset_columns' | ppTranslate"
        ppStyle="text"
        ppId="resetTableBtn"
        (ppAction)="resetColumns()"
      >
        {{ 'clear_all' | ppTranslate }}
      </pp-button>

      <pp-button ppStyle="primary" ppId="resetTableDoneBtn" (ppAction)="hideDropdown()">
        {{ 'done' | ppTranslate }}
      </pp-button>
    </div>
  </footer>
</section>
